import React, { useEffect, useState } from "react";
import { Close } from "@material-ui/icons";
import { FORM_TYPES } from "common/utils/formUtility";
import { useSelector } from "react-redux";
import * as R from "ramda";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  makeStyles,
  Divider,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import LessonPlanForm from "./LessonPlanForm";
import { getDetailsById, onAddValue } from "components/listOfValues/utils";
import { PAGES } from "state/slices/pageSlice";

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  annualPlanCard: {
    marginBottom: "30px",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "end",
  },
  heading: {
    fontWeight: 800,
    fontSize: "18px",
    color: "#263657",
  },
  divider: {
    margin: "0 24px 24px 24px",
  },
}));

function LessonPlanModal({
  userRoles,
  setModalState,
  modalState,
  getPlanList,
  subUnits,
  unitData,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));

  const [state, setState] = useState({
    start: "",
    end: "",
    unitPlanId: unitData.id,
    name: "",
    lessonPlanForm: null,
    curriculumContext: {
      schoolCode: "",
    },
    subUnits: [],
    unitTlmList: null,
    unitLearningOutcomes: null,
  });
  const isEditForm = modalState.isEdit || false;
  const annualPlanFormData = useSelector(
    (state) => state.globalForm[FORM_TYPES.ANNUAL_PLAN_FORM]
  );

  const AllowedRoles = ["System Administrator", "Administrator"];

  useEffect(() => {
    const { data } = modalState;
    if (isEditForm && data?.id) {
      getPlanDetails(data.id);
    }
  }, [isEditForm]);

  const getPlanDetails = async (id) => {
    const response = await getDetailsById("/lesson-plan", id);
    setState(response || null);
  };

  const handleClose = () => {
    setModalState((prev) => ({
      isOpen: false,
      data: null,
      isEdit: false,
    }));
  };

  const handleChange = (path, value) => {
    setState((prev) => {
      const data = R.assocPath(path, value, prev);
      return data;
    });
  };

  const isEditEnabled = (roles) => {
    let editEnabled = false;
    if (roles && roles.length > 0) {
      roles.forEach((role) => {
        if (R.includes(role, AllowedRoles)) {
          editEnabled = true;
        }
      });
    }
    return editEnabled;
  };

  const isReadOnly = isEditEnabled(userRoles)
    ? false
    : R.propOr("", "status", annualPlanFormData) === "COMPLETED";

  const handleSubmit = async () => {
    const payload = {
      ...state,
      subUnits: state?.subUnits?.map((item) => ({ name: item.name })) || [],
    };
    const response = await onAddValue(payload, PAGES.lessonPlan);
    getPlanList();
    setModalState({
      isOpen: false,
      isEdit: false,
      data: null,
    });
  };

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      fullScreen={isSmallDevice}
      open={modalState?.isOpen}
      onClose={() => setModalState((prev) => ({ ...prev, isOpen: false }))}
      ariaLabeledBy="form-dialog-title"
    >
      <Grid container>
        <Grid item xs={10} md={11}>
          <DialogTitle id="form-dialog-title">
            <Typography variant="h6" className={classes.heading}>{`${
              isEditForm ? "Edit" : "Add"
            } Lesson Plan`}</Typography>
          </DialogTitle>
        </Grid>
        <Grid item xs={2} md={1} className={classes.modalCloseBtn}>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Grid>
      </Grid>
      <Divider />
      <DialogContent style={{ padding: "8px 25px" }}>
        <Box>
          <LessonPlanForm
            isEditForm={isEditForm}
            isReadOnly={isReadOnly}
            state={state}
            userRoles={userRoles}
            handleChange={handleChange}
            subUnits={subUnits}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
              pt: 2,
            }}
          >
            <Button
              color="primary"
              //   disabled={activeStep === 0 || isReadOnly || isNew}
              variant="contained"
              onClick={handleSubmit}
              data-html2canvas-ignore
            >
              Submit
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default LessonPlanModal;
